import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type {
    MonitoringAdapter,
    MonitoringFigure,
} from '@app/modules/monitor/models/monitoring.model';
import { MONITORING_PATH } from '@app/shared/constants/api-route.config';
import {
    type ItemResponse,
    type StatusResponse,
    WithCrudService,
} from '@app/shared/services/mixins/crud.service';
import { WithJobService } from '@app/shared/services/mixins/job.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { RestService } from '@app/shared/services/rest.service';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class MonitoringService extends classes(
    WithCrudService<MonitoringAdapter>,
    WithJobService,
    WithLogService,
) {
    protected endpoint = MONITORING_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);

    getStatsFigures(
        monitoringId: number,
        startDate: string | null,
        endDate: string | null,
    ): Observable<{ result: MonitoringFigure[] }> {
        return this.api.getWithParams(`${this.endpoint}${monitoringId}/stats/figures`, {
            startDate,
            endDate,
        });
    }

    saveStatsFigure(
        monitoringId: number,
        figure: Partial<MonitoringFigure>,
    ): Observable<ItemResponse<MonitoringFigure>> {
        return this.api.post(`${this.endpoint}${monitoringId}/stats/figure`, figure);
    }

    runStatsFigure(
        monitoringId: number,
        figureId: number,
        startDate: string | null,
        endDate: string | null,
    ): Observable<ItemResponse<MonitoringFigure>> {
        return this.api.getWithParams(`${this.endpoint}${monitoringId}/stats/figure/${figureId}`, {
            startDate,
            endDate,
        });
    }

    deleteStatsFigure(monitoringId: number, figureId: number): Observable<StatusResponse> {
        return this.api.delete(`${this.endpoint}${monitoringId}/stats/figure/${figureId}`);
    }
}
